define('views/base',[
  'jquery',
  'settings',
  'lazyload',

  'utils/sticky',
  'utils/tooltip-init',
  'utils/bind-manager',
  'utils/cookies',
  'utils/is-in-view',
  'utils/debounce',
  'utils/local-storage',

  'views/quick-cart',
  'views/search-suggestions',
  'connections/product-connection',

  'modules/menu',
  'modules/overlay-box',
  'modules/pop-over',
  'modules/header-profile',
  'modules/split-button',
  'modules/alert-box',
  'modules/notification',
  'modules/recent-products',
  'modules/slideshow',
  'modules/faq',
  'modules/priceXhr',
  'modules/product-card-addtocart',
  'modules/wishlist-products',
  'modules/popup-content-box',

  'libs/respond/respond',
  'libs/mousetrap/mousetrap.min'
], function (
  $,
  settings,
  LazyLoad,
  Sticky,
  tooltipInit,
  bindMng,
  cookies,
  inView,
  debounce,
  localStorage,
  QuickCart,
  SearchSuggestionsLive,
  ProductConnection,
  Menu,
  OverlayBox,
  PopOver,
  headerProfile,
  splitButton,
  AlertBox,
  Notification,
  RecentProducts,
  Slideshow,
  Faq,
  priceXhr,
  ProductCardAddToCart,
  WishListProducts,
  PopupContentBox,
  respond,
  MouseTrap
) {
  var BaseView = (function () {
    function BaseView() {}

    BaseView.prototype.initNavigationBar = function () {
      var $bar = $('.navigation-bar'),
        stickyBar;

      // Always make sure that the element actually exists
      if ($bar.length) {
        stickyBar = new Sticky($bar);

        stickyBar.setStickyClass('navigation-bar--fixed');
        stickyBar.init();

        respond.atBreakpoint(
          settings.breakpoints.medium.min,
          settings.breakpoints.medium.max,
          function () {
            stickyBar.enable();
          },
          function () {
            stickyBar.disable();
          }
        );
      }
    };

    BaseView.prototype.initPriceScrollListener = function () {
      window.addEventListener('scroll', function () {
        this.updateVisiblePrices();
      });
    };

    /**
     *  Add listener that resizes rss blocks with different heights.
     */
    BaseView.prototype.initRssBlock = function () {
      var rssBlockContainer = $('.rss-block');
      if (!rssBlockContainer.length) return;

      var texts = rssBlockContainer.find('.newslisting-block__featured .text');
      var resizeTexts = function () {
        texts.height('auto');

        var highest = 0;
        texts.each(function (i, el) {
          if (el.clientHeight > highest) highest = el.clientHeight;
        });
        texts.each(function (i, el) {
          $(el).height(highest);
        });
      };
      var debouncedHandler = debounce(resizeTexts, 400);

      $(window).on('resize', debouncedHandler);
      resizeTexts(); // Run once on load.
    };

    /**
     * Checks if any product price is visible and not loaded. If needed, it loads the price from ERP,
     * shows it to the user and removes it from future checks.
     */
    BaseView.prototype.updateVisiblePrices = function () {
      if ($('#profile-hide-prices').prop('checked')) return;

      $('.product__price__container.product__price--notloaded').each(function (i, el) {
        var $el = $(el);
        if (inView($el, 0, 1000)) {
          var productNumber = $el.closest('article').data('productId');
          $el.removeClass('product__price--notloaded').append('<span class="loader-small"></span>');

          var xhr = ProductConnection.getProductPriceView(productNumber);
          priceXhr.xhrList.push(xhr);
          xhr.then(
            function (res) {
              $el.html(res);
            },
            function (error) {
              $el.addClass('product__price--notloaded').empty().append('&nbsp;');
            }
          );
        }
      });
    };

    BaseView.prototype.initLazyLoad = function () {
      window.LazyLoadInstance = new LazyLoad({
        elements_selector: '.product__image--lazy',
        threshold: 400,
        callback_error: function (el) {
          el.src = $(el).data('fallback');
        },
        callback_processed: function (el) {
          var $emptyImg = $(".product__image--lazy.loading[data-original='']");

          // Use fallback img if the product image url is missing
          $emptyImg.each(function (i) {
            this.src = $(this).data('fallback');
          });
        }
      });
    };

    BaseView.prototype.initRecentProducts = function () {
      var recentProductsContainers = $('.recent-products');
      if (!recentProductsContainers.length) return;

      $.each(recentProductsContainers, function (i, container) {
        var recentProductsView = new RecentProducts($(container));
        recentProductsView.init();
      });
    };

    BaseView.prototype.initWishList = function () {
      var wishListContainers = $('.wishlist-products');
      if (!wishListContainers.length) return;

      $.each(wishListContainers, function (i, container) {
        var wishList = new WishListProducts($(container));
        //wishList.init();
        wishList.initBindings();
      });
    };

    BaseView.prototype.initSlideshow = function () {
      var slideshowContainer = $('.slideshow');
      if (!slideshowContainer.length) return;

      slideshowContainer.each(function () {
        var slideshow = new Slideshow($(this));
        slideshow.init();
      });
    };

    BaseView.prototype.initFaq = function () {
      var faqContainer = $('.faq_field');
      if (!faqContainer.length) return;

      faqContainer.each(function () {
        var faq = new Faq($(this));
        faq.init();
      });
    };

    BaseView.prototype.initMenu = function () {
      Menu.call();
      QuickCart.init();
      SearchSuggestionsLive.init();
    };

    BaseView.prototype.initGlobalShortcuts = function () {
      MouseTrap.bind(['s', '/'], function (event) {
        if (!$(event.target).is('input')) {
          event.preventDefault();
          $('#search-query').focus();
        }
      });

      MouseTrap.bind('esc', function (event) {
        $(event.target).blur();
      });
    };

    BaseView.prototype.initTooltips = function () {
      tooltipInit($('body'));
    };

    BaseView.prototype.initDisabled = function () {
      BindMng.add($('[data-disabled]'), 'click', function () {
        if ($(this).attr('data-disabled') === 'disabled') {
          return false;
        }

        return true;
      });
    };

    BaseView.prototype.initPopOvers = function () {
      var inited = [];

      $('[data-pop-over]').each(function () {
        var contentString = $(this).attr('data-pop-over');
        if ($.inArray(contentString, inited) < 0) {
          switch (contentString.substr(0, 1)) {
            case '#':
            case '.':
              content = $(contentString);
              break;

            case ':':
              content = $('<div>' + contentString.substr(1, contentString.length) + '</div>');
              break;

            default:
              content = contentString;
          }

          var triggers = $('[data-pop-over="' + contentString + '"]'),
            popOver = new PopOver(triggers, content);

          inited.push(contentString);
          popOver.openOn('click');
        }
      });
    };

    BaseView.prototype.initPageLoadNotification = function () {
      $('.page-load-notification').each(function () {
        var notification = new Notification($(this));
        notification.show();
      });
    };

    BaseView.prototype.initPageLoadAlert = function () {
      $('.page-load-alert__hook').each(function () {
        var contentString = $(this).text();

        if (contentString) {
          var ab = new AlertBox(contentString);
          ab.addCTA('OK');
          ab.show();
        }
      });
    };

    BaseView.prototype.initPageLoadPopupContentBox = function () {
      $('.page-load-popup-content__hook').each(function () {
        var never = localStorage.get('popup-content-block__never', false);

        if (never === true) return;

        /* To be used if session based on browser tab, instead of browser instance */
        // var displayed = localStorage.get('popup-content-block__displayed', true);

        // if (!Array.isArray(displayed)) {
        //     displayed = [];
        // }

        //var id = $(this).data('popup-contentid');

        var serverSessionSet = $(this).data('popup-server-session');

        if (serverSessionSet == false) {
          // && id > 0 && displayed.indexOf(id) < 0) {
          var pb = new PopupContentBox($(this).data('template-url'));
          pb.show();

          displayed.push(id);

          localStorage.set('popup-content-block__displayed', displayed, true);
        }
      });
    };

    BaseView.prototype.initCookieNotice = function () {
      if (!cookies.get('cookieNoticeAccepted')) {
        var $cookieNotice = $('#cookieNotice'),
          acceptedClass = 'cookie-notice--accepted';

        $cookieNotice.removeClass(acceptedClass);

        $('#cookieNoticeClose').on('click', function (event) {
          event.preventDefault();
          $cookieNotice.addClass(acceptedClass);

          cookies.set('cookieNoticeAccepted', 'true', 365);
        });
      }
    };

    BaseView.prototype.initProductCardQuickAdd = function () {
      window.productCardAddToCart = ProductCardAddToCart;

      var isOutlet = $('[data-outlet="true"]').length > 0;
      ProductCardAddToCart.init(isOutlet);
    };

    BaseView.prototype.initProductPdfButtons = function () {
      $(document).on('click', '[select-price]', function (e) {
        e.preventDefault();
        var ob = new OverlayBox(settings.templates.pdfPriceConfirm, {});
        ob.setup();
        var url = $(this).attr('href');
        ob.load(function () {
          ob.show();
          $('[confirm-pdf-price]').one('click', function () {
            var urlField1 = ob.container.find('input[name=price-pdf-radio]:checked');
            var urlField2 = ob.container.find('input[name=include-technical-specifications]:checked');
            window.location.href =
              url + '&priceViewSetting=' + urlField1.val() + '&technicalSpecifications=' + urlField2.val();
            ob.destroy();
          });
        });
      });
    };

    BaseView.prototype.initTabs = function () {
      var $tabs = $('.tabs');
      if (!$tabs.length) return;

      var labelHeight = $tabs.find('label').outerHeight();

      function setTabsHeight(content) {
        $tabs.css('height', labelHeight + content.outerHeight(true) + 'px');
      }

      var debouncedSetTabHeight = debounce(setTabsHeight, 300);

      function getTrigger(el) {
        return function () {
          var $tab = el.siblings('input');
          if ($tab.is(':checked')) debouncedSetTabHeight(el);
        };
      }

      $tabs.on('change', '.tab>input', function () {
        setTabsHeight($(this).siblings('.tab_content'));
      });

      // Observe tab content additions.
      var targetNode = $tabs.get(0);
      var config = { attributes: true, childList: true, subtree: true };
      var callback = function (mutationsList) {
        // Use traditional 'for loops' for IE 11
        for (var i = 0; i < mutationsList.length; i++) {
          var $target = $(mutationsList[i].target);
          var $contentEl = $target.is('.tab_content') ? $target : $target.parents('.tab_content');

          if ($contentEl.length) {
            setTimeout(getTrigger($contentEl, debouncedSetTabHeight), 500);
          }
        }
      };

      // Create an observer instance linked to the callback function
      var observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);

      setTabsHeight($tabs.find('.tab_content').first());
    };

    /**
     * Init any sticky action components visible on the page
     */
    BaseView.prototype.initStickyActions = function () {
      var $actions = $('[data-sticky-actions]');

      if (!$actions.length) return;

      var stickyHandler = this.getStickyHandler($actions);

      stickyHandler();
      $(document).on('scroll', debounce(stickyHandler, 100));
    };

    /**
     * Closure for handling sticking the action buttons to the top.
     * Places it under the navbar.
     * @return {Function} - Scroll handler.
     */
    BaseView.prototype.getStickyHandler = function ($stickyActionEl) {
      var navHeight = $('.navigation-bar').height();
      var offset = $stickyActionEl.offset().top - navHeight;
      var fixed = false;

      return function () {
        var scrollTop = $(window).scrollTop();
        var width = $(document).width();

        if (width > 768 && scrollTop > offset && !fixed) {
          fixed = true;
          $stickyActionEl.addClass('sticky-actions--fixed');
        } else if (scrollTop < offset && fixed) {
          $stickyActionEl.removeClass('sticky-actions--fixed');
          fixed = false;
        }
      };
    };

    return BaseView;
  })();

  return function () {
    var v = new BaseView();

    v.initNavigationBar();
    v.initMenu();
    v.initGlobalShortcuts();
    //v.initTooltips();
    v.initPopOvers();
    v.initCookieNotice();
    v.initPageLoadNotification();
    v.initPageLoadAlert();
    v.initPageLoadPopupContentBox();
    v.initRecentProducts();
    v.initWishList();
    v.initSlideshow();
    v.initFaq();
    v.initRssBlock();
    v.initLazyLoad();
    v.initPriceScrollListener();
    v.initProductCardQuickAdd();
    v.initProductPdfButtons();
    v.initTabs();
    v.initStickyActions();
    window.updateVisiblePrices = BaseView.prototype.updateVisiblePrices;
  };
});

